export enum JobCreateTabRoutes {
	DETAILS = 'details',
	BILLING_CODES = 'billingCodes',
	JOB_HAZARD_ASSESSMENT = 'jobHazardAssessment',
	ATTACHMENTS = 'attachments',
}
